import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuthStore } from '../store/auth.store';
/**
 * Hook for user logout.
 * This hook centralizes the logout process by calling the `logout` action from the `useAuthStore`,
 * which is the single source of truth for auth state management and cleanup.
 */
export const useLogout = () => {
    const queryClient = useQueryClient();
    const logoutAction = useAuthStore(state => state.logout);
    return useMutation({
        mutationFn: () => logoutAction(queryClient),
        // The onSuccess callback is no longer needed here because the store's `logout` action
        // already performs a more comprehensive cleanup, including `queryClient.clear()`.
    });
};
//# sourceMappingURL=useLogout.js.map